import ProfilePage from "../Profile/Profile";

const UserProfile = (props) => <ProfilePage {...props} />;

export default UserProfile;
